import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgFacebookLogoSmall = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#src__com__yext__listingslaunchstorm__public__icons__facebook-logo-small_svg__a)">
        <path
          d="M10 17.144a7.143 7.143 0 1 0 0-14.286 7.143 7.143 0 0 0 0 14.286Z"
          fill="#1977F3"
        />
        <path
          d="m12.78 12.066.317-2.065h-1.98v-1.34c0-.564.276-1.116 1.163-1.116h.902V5.787s-.818-.14-1.6-.14c-1.63 0-2.698.989-2.698 2.78v1.574H7.07v2.065h1.814v4.992a7.178 7.178 0 0 0 2.232 0v-4.992h1.665Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="src__com__yext__listingslaunchstorm__public__icons__facebook-logo-small_svg__a">
          <path
            fill="#fff"
            transform="translate(2.857 2.857)"
            d="M0 0h14.286v14.286H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgFacebookLogoSmall;
